import { feature, mesh } from "topojson-client";
import { getAbsoluteUrl } from "$utils/urls.js";
import { setContext, getContext, onMount } from "svelte";

/** @typedef {import("$utils/types.d.ts").GeoLevel} GeoLevel */

class MapData {
  stateFeatures = $state(new Promise(() => {}));
  districtFeatures = $state(new Promise(() => {}));
  constructor() {
    let stateUrl = this.getFeatureUrl("state");
    let districtUrl = this.getFeatureUrl("district");
    onMount(() => {
      this.stateFeatures = this.fetchData(stateUrl).then((topoData) => {
        return feature(topoData, topoData.objects.states);
      });
      this.districtFeatures = this.fetchData(districtUrl).then((topoData) => {
        return feature(topoData, topoData.objects.districts);
      });
    });
  }

  /**
   * @param {GeoLevel} level
   * @returns {string}
   */
  getFeatureUrl(level) {
    return getAbsoluteUrl(`/data/topo/${level}_topo.json`);
  }

  async fetchData(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
}

const contextKey = Symbol("mapContext");

export function createMapData() {
  let data = new MapData();
  setContext(contextKey, data);
  return data;
}

export function useMapData() {
  return getContext(contextKey);
}
